<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model">
      <el-form ref="form" :model="model">
        <el-form-item label="别名(上传名称)" prop="name">
          <el-input v-model="model.alias" disabled />
        </el-form-item>
        <el-form-item label="标准名称" prop="factorId" :rules="[{
          required: true,
          message: '请选择因子标准名称'
        }]">
          <section class="tree-container border" style="height:480px;">
            <el-tree
              v-if="showTree"
              ref="tree"
              :data="tree"
              :props="{
                label: 'name'
              }"
              highlight-current
              :current-node-key="model.factorId"
              :default-expanded-keys="[model.factorId]"
              auto-expand-parent
              node-key="id"
              @current-change="onFactorIdChanged"
            />
          </section>
        </el-form-item>
      </el-form>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  data: () => ({
    showTree: false
  }),
  computed: {
    tree () {
      let factors = Object.values(this.profileSiteDevices.reduce((map, siteDevice) => siteDevice.status ? siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        if (siteDeviceFactor.status) {
          let {factorId} = siteDeviceFactor

          if (!map[factorId]) {
            map[factorId] = {
              id: factorId,
              name: siteDeviceFactor.name,
              parentId: siteDeviceFactor.parentId
            }
          }
        }

        return map
      }, map) : map, {}))

      let factorGroupMap = this.factorGroups.reduce((map, factorGroup) => {
        let {id} = factorGroup
        map[id] = {
          id,
          name: factorGroup.name,
          parentId: factorGroup.parentId
        }
        return map
      }, {})

      let roots = []

      for (let i = 0; i < factors.length; i++) {
        let factor = factors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent) {
          let {children} = parent

          if (!children) {
            children = parent.children = []
            factors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    }
  },
  methods: {
    initModel () {
      return {
        alias: null,
        factorId: null
      }
    },
    afterGetDetail (model) {
      // let {tree} = this.$refs
      // tree.setCurrentKey(model.factorId)
      this.showTree = true
    },
    onFactorIdChanged (data) {
      if (data.children) {
        this.$refs.tree.setCurrentKey(this.model.factorId)
      } else {
        this.model.factorId = data.id
      }
    }
  },
  watch: {
    opened (opened) {
      if (!opened) {
        this.showTree = false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/07Factor-Alias/Editor.vue